export type PromptMessageVariant = 'info' | 'success' | 'warning' | 'error' | 'suspension';

interface IPromptMessageVariantStyles {
  container: string;
  icon: string;
}

interface IPromptMessageVariants {
  [key: string]: IPromptMessageVariantStyles;
}

export const PROMPT_MESSAGE_VARIANTS: IPromptMessageVariants = {
  info: {
    container:
      'bg-semantic-info-light border-blue-lighter dark:bg-blue-darker dark:border-blue-dark',
    icon: 'text-semantic-info-base dark:!text-blue-base',
  },
  success: {
    container:
      'bg-semantic-success-light border-green-lighter dark:bg-green-darker dark:border-green-dark',
    icon: 'text-semantic-success-base dark:!text-green-base',
  },
  warning: {
    container:
      'bg-semantic-warning-light border-yellow-lighter dark:bg-yellow-darker dark:border-yellow-dark',
    icon: 'text-semantic-warning-base dark:!text-yellow-base',
  },
  error: {
    container: 'bg-semantic-error-light border-red-lighter dark:bg-red-darker dark:border-red-dark',
    icon: 'text-semantic-error-base dark:!text-red-base',
  },
  suspension: {
    container: 'bg-opacity-dark-5 border-opacity-dark-10',
    icon: '!text-neutral-9',
  },
};
